import type { PublicModuleCatalogEntryResponse } from '@tabita/contracts';

/**
 * The module picker's own tiny dependency closure — deliberately not a
 * shared import of module-registry-service's graph algorithms, since a web
 * bundle never depends on a backend service package. The catalog's own
 * `dependencies` field is all a picker needs: walk it to find what
 * selecting a module requires, or what still needs it before it can go.
 */
export function withDependencies(
  moduleKey: string,
  catalog: readonly PublicModuleCatalogEntryResponse[],
): string[] {
  const byKey = new Map(catalog.map((entry) => [entry.key, entry]));
  const closure = new Set<string>();
  const queue = [moduleKey];

  while (queue.length > 0) {
    const key = queue.pop()!;
    if (closure.has(key)) continue;
    closure.add(key);
    for (const dependency of byKey.get(key)?.dependencies ?? []) {
      queue.push(dependency);
    }
  }

  return [...closure];
}
